/**
 * @module app.ext.mcg-informed
 */

import { appendOrdinalSuffixDisplay, isNullOrUndefined } from 'app/shared/lib/utilities';
import { getYear } from 'date-fns';

export function replaceCopyrightText(copyright: string, edition?: string): string {
    if(isNullOrUndefined(edition) || Number.isNaN(parseInt(edition))) edition = '1';
    const editionWithOrdinalSuffix = appendOrdinalSuffixDisplay(Number(edition));
    const year = getYear(Date.now()).toString();
    return copyright.replace('{EditionWithOrdinalSuffix}', editionWithOrdinalSuffix).replace('{Year}', year);
}
